import * as z from "zod";

export const getNonPickedProductIds = {
  name: "getNonPickedProductIds" as const,
  input: z.object({ productIds: z.array(z.string()) }),
  output: z.object({
    nonPickedProductIds: z.array(z.string()),
    poolAllocations: z.record(z.string(), z.number()),
  }),
};
